import React, { createContext, useState, useContext, useEffect } from 'react';

// Create a Context for the heading
const HeadingContext = createContext();

// Create a custom hook to use the heading context
export const useHeading = () => {
  return useContext(HeadingContext);
};

export const HeadingProvider = ({ children }) => {
  const [heading, setHeading] = useState("");

  // Fetch the existing heading when the component mounts
  useEffect(() => {
    const fetchHeading = async () => {
      try {
        const response = await fetch(
          'https://bombaydentalcompany.com/bombaydentalcompanyapi/get_heading.php'
        );
        if (response.ok) {
          const data = await response.text();
           // Assuming the response is plain text
          setHeading(JSON.parse(data).data.heading); // Set the heading from API
        } else {
          console.error('Failed to fetch heading:', response.statusText);
        }
      } catch (error) {
        console.error('Error fetching heading:', error);
      }
    };

    if (!heading) fetchHeading(); // Only fetch if heading is not set yet
  }, [heading]); // Runs only on mount and when heading is empty

  const updateHeading = (newHeading) => {
    setHeading(newHeading);
  };

  // Context value contains the heading and the function to update it
  return (
    <HeadingContext.Provider value={{ heading, setHeading: updateHeading }}>
      {children}
    </HeadingContext.Provider>
  );
};
